import React from 'react';
import Fade from 'react-reveal/Fade';
import { FlexCol } from "../../Styles";
import './index.css';

const CompanyItem = (props) => {
  const styles = {
    transform: 'translateY(50%)'
  }


  return (
    <FlexCol basis="35%" className="project-slab" style={props.shiftIt === "yes" ? styles : { paddingBottom: 20 }}>
      {/* <img
        style={{ objectFit: 'fill', objectPosition: 'top', height: 240, width: 450, border: '5px solid ' + primaryFgColor, borderRadius: 9 }}
        src={props.info.img ? props.info.img : 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fdesignshack.net%2Fwp-content%2Fuploads%2Fplaceholder-image.png&f=1&nofb=1'}
      /> */}
      <div className="computer-display">
        <img
          className="computer-screen"
          src={props.info.img ? props.info.img : 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fdesignshack.net%2Fwp-content%2Fuploads%2Fplaceholder-image.png&f=1&nofb=1'}
          alt="Project Frame"
        />
      </div>
      <div className="computer-keyboard"></div>

      <div style={{ textAlign: 'justify', fontWeight: 300 }}>
        <br />
        <Fade down>
          <b>{props.info.name}</b>
        </Fade>
        <Fade down delay={200}>
          {props.info.date}
        </Fade>
        <Fade down delay={300}>
          {props.info.languages}
        </Fade>
        <br />
        <Fade down delay={400}>
          {props.info.about}
        </Fade>
        <br />
        <Fade down delay={500}>
          <div dangerouslySetInnerHTML={{ __html: props.info.point }} style={{ textAlign: 'left' }} />
        </Fade>
      </div>
    </FlexCol>
  );
}

export default CompanyItem;